const pageNameKey = "nodeManagerInfoBarPillsNav";

export const nodeManagerInfoBarPillsNavEn = {
  [pageNameKey]: {
    navTextTreeStructure: "Tree Structure",
    navTextDashboard: "Dashboard",
    navTextConditionMonitoring: "Condition Monitoring",
    navTextOneShot: "One Shot",
    navTextShotDataTable: "Shot data table",
    navTextOTA: "Machine Settings",
  },
};

export const nodeManagerInfoBarPillsNavPtBr = {
  [pageNameKey]: {
    navTextTreeStructure: "Estrutura de árvore",
    navTextDashboard: "Dashboard",
    navTextConditionMonitoring: "Monitoramento de condição",
    navTextOneShot: "One Shot",
    navTextShotDataTable: "Tabela de dados shot",
    navTextOTA: "Configurações da máquina",
  },
};

export const nodeManagerInfoBarPillsNavDe = {
  [pageNameKey]: {
    navTextTreeStructure: "Tree Structure",
    navTextDashboard: "Dashboard",
    navTextConditionMonitoring: "Condition Monitoring",
    navTextOneShot: "One Shot",
    navTextShotDataTable: "Shot-Datentabelle",
    navTextOTA: "Maschineneinstellungen",
  },
};

export const nodeManagerInfoBarPillsNavZhHans = {
  [pageNameKey]: {
    navTextTreeStructure: "树结构",
    navTextDashboard: "仪表盘",
    navTextConditionMonitoring: "条件监控",
    navTextOneShot: "单次执行",
    navTextShotDataTable: "注射数据表",
    navTextOTA: "机器设置",
  },
};

export const nodeManagerInfoBarPillsNavIt = {
  [pageNameKey]: {
    navTextTreeStructure: "Struttura nodi",
    navTextDashboard: "Dashboard",
    navTextConditionMonitoring: "Monitoraggio condizioni",
    navTextOneShot: "One Shot",
    navTextShotDataTable: "Tabella dati shot",
    navTextOTA: "Impostazioni della macchina",
  },
};

export const nodeManagerInfoBarPillsNavEs = {
  [pageNameKey]: {
    navTextTreeStructure: "Estructura en árbol",
    navTextDashboard: "Dashboard",
    navTextConditionMonitoring: "Monitorización de condiciones",
    navTextOneShot: "One Shot",
    navTextShotDataTable: "Tabla de datos shot",
    navTextOTA: "Configuración de la máquina",
  },
};

export const nodeManagerInfoBarPillsNavNl = {
  [pageNameKey]: {
    navTextConditionMonitoring: "Conditiebewaking",
    navTextDashboard: "Dashboard",
    navTextOTA: "Machine-instellingen",
    navTextOneShot: "One Shot",
    navTextShotDataTable: "Shot-gegevenstabel",
    navTextTreeStructure: "Boomstructuur",
  },
};

export const nodeManagerInfoBarPillsNavTr = {
  [pageNameKey]: {
    navTextConditionMonitoring: "Durum İzleme",
    navTextDashboard: "Kontrol Paneli",
    navTextOTA: "Makine Ayarları",
    navTextOneShot: "Tek Atış",
    navTextTreeStructure: "Ağaç Yapısı",
    navTextShotDataTable: "Atış verileri tablosu",
  },
};
